import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';
import { FluentFilterCollection, Operator } from '@/common/services';

export function getUsersNumber(groupId: number) {
    const filters = new FluentFilterCollection().where('id').filter(Operator.IsEqualTo, groupId);

    const q = new CoreQuery()
        .entity([EntitiesList.USER_GROUPS, EntitiesList.PERSONA, EntitiesList.USER_GROUP, EntitiesList.USERS_NUMBER])
        .filters(filters);

    return httpClientCoreQuery.get<number>(q).then(({ data }) => data);
}
